import { Base } from "../../../base/components/base"
import { Img } from "../../../base/components/native/img"
import { ROUND, WH } from "../../../base/helpers/style"
import ldb from "../../../base/lib/ldb"
import router from "../../../base/lib/router"
import { IMAGES } from "../../../configs/images"

export const ProfileIcon = () => {
    const base = Base()

    const img = Img(IMAGES.ICONS.PROFILE, { height: 22})
    base.append(img)

    base.el.onclick = () => {
      if (ldb.get('DANESHFX_USER'))   router.goto('/user')
      else router.goto('/login')
    }

    base.cssClass({
        margin: '20px',
        // backgroundColor: '#222',
        ...WH(22),
        // ...ROUND
    })

    return base
}